import { BuildTargetId, Changelog } from "../types";

class ChangelogService {
    static async getChangelogList({ buildTargetId }: { buildTargetId: BuildTargetId }): Promise<Changelog[]> {
        const url = `https://api-build.cdmvision.dev/api/v2/apps/projects/supar/buildtargets/${buildTargetId}/changelogs`;
        const response = await fetch(url, { mode: "cors" });
        const data = await response.json();

        return data;
    }
}

export default ChangelogService;
